import { render } from "./CardAuction.vue?vue&type=template&id=3beb7a0b"
import script from "./CardAuction.vue?vue&type=script&lang=js"
export * from "./CardAuction.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__